// extracted by mini-css-extract-plugin
export var actions = "_uc-4";
export var item = "_uc-1";
export var price = "_uc-3";
export var quantity = "_uc-2";
export var table = "_uc-0";